<template lang="pug">
section
    el-form-item.grow(:label="$t('Name')" prop="name")
        el-input(
            type="text"
            v-model="name"
            maxlength="255"
            show-word-limit
        )
    el-form-item(:label="$t('Description')" prop="description")
        quill-editor(v-model="description" :options="quillConfig")
    el-form-item.hidden-toggle(label="" prop="hidden")
        el-switch(
            :active-text="$t('Hidden on public newsletter signup')"
            v-model="hidden"
        )
        .help {{ $t('hidden-info') }}
    el-form-item(label="" prop="force")
        el-switch(
            :active-text="$t('Cannot be unsubscribed')"
            inactive-color="#ff4949"
            v-model="force"
        )
    //- add force info
    .alert.alert-info(v-html="$t('force-info')")
</template>

<i18n>
{
    "en": {
        "force-info": "<p><strong>Note on the option \"Cannot be unsubscribed\":</strong><br>This setting should only be used for strictly necessary system emails that are essential for platform operation and have no promotional purpose (e.g. notifications about planned maintenance, system updates, or security-related announcements).</p><p>Enabling this option for regular informational or marketing newsletters may constitute a <strong>violation of data protection and competition laws</strong>. Recipients must always have the option to withdraw their consent to receive such emails (in accordance with Article 7(3) GDPR and Section 7 of the German UWG).</p><p>Misuse of this option can result in <strong>warnings, fines,</strong> or other legal consequences. Use this setting only when the delivery of such emails is legally mandatory.</p>",
        "hidden-info": "Hidden topics are not offered on public signup forms. Members already subscribed can still manage and unsubscribe from them."
    },
    "de": {
        "Name": "Name",
        "Description": "Beschreibung",
        "Cannot be unsubscribed": "Kann nicht abgemeldet werden",
        "Hidden on public newsletter signup": "Bei öffentlicher Newsletter-Anmeldung ausgeblendet",
        "hidden-info": "Ausgeblendete Themen werden auf öffentlichen Anmeldeformularen nicht angeboten. Bereits angemeldete Mitglieder können sie weiterhin verwalten und sich davon abmelden.",
        "force-info": "<p><strong>Hinweis zur Option \"Kann nicht abgemeldet werden\":</strong><br>Diese Einstellung sollte ausschließlich für zwingend notwendige System-E-Mails verwendet werden, die für den Betrieb der Plattform erforderlich sind und keinen werblichen Charakter haben (z. B. Ankündigungen geplanter Wartungsarbeiten, System-Updates oder sicherheitsrelevante Mitteilungen).</p><p>Wird diese Option bei regulären Informations- oder Marketing-Newslettern aktiviert, kann dies einen <strong>Verstoß gegen Datenschutz- und Wettbewerbsrecht</strong> darstellen. Empfänger müssen jederzeit die Möglichkeit haben, den Erhalt solcher E-Mails abzulehnen (Widerruf der Einwilligung gemäß Art. 7 Abs. 3 DSGVO und § 7 UWG).</p><p>Eine missbräuchliche Nutzung dieser Option kann zu <strong>Abmahnungen, Bußgeldern</strong> oder anderen rechtlichen Konsequenzen führen. Verwenden Sie diese Einstellung daher nur, wenn der Versand rechtlich zwingend erforderlich ist.</p>"
    }
}
</i18n>

<script>

import _ from 'lodash'
// import Vue from 'vue'

import quillConfig from '@/quill/config'
import { useNewsletterSubscriptionTopicStore } from '@/stores'

export default {
    name: 'Main',
    data() {
        return {
            quillConfig,
        }
    },
    computed: {
        subscriptionTopicStore() {
            return useNewsletterSubscriptionTopicStore();
        },
        form() {
            return this.subscriptionTopicStore.form;
        },
        name: {
            get() {
                return _.get(this.form, 'name', '')
            },
            set(value) {
                this.subscriptionTopicStore.setFormName(value)
            }
        },
        description: {
            get() {
                return _.get(this.form, 'description', '')
            },
            set(value) {
                this.subscriptionTopicStore.setFormDescription(value)
            }
        },
        force: {
            get() {
                return _.get(this.form, 'force', false)
            },
            set(value) {
                this.subscriptionTopicStore.setFormForce(value)
            }
        },
        hidden: {
            get() {
                return _.get(this.form, 'hidden', false)
            },
            set(value) {
                this.subscriptionTopicStore.setFormHidden(value)
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.alert.alert-info
    margin-bottom: 0

.hidden-toggle
    margin-bottom: 28px

.help
    line-height: 1.4
</style>
